import { createWebHistory, createRouter } from "vue-router";
import store                    from "@/store";
import NProgress                from "nprogress";
/*For Errors Component*/
import NotFound                 from "@/components/errors/NotFound.vue";

/*For Auth Component*/
import AuthLayout               from "@/components/layouts/AuthLayout.vue";
import Login                    from "@/components/auth/Login.vue";

/*For Dashboard Component*/
import DashboardLayout          from "@/components/layouts/AdminLayout.vue";
import Dashboard                from "@/components/pages/Dashboard.vue";
import Users                    from "@/components/pages/Users.vue";
import Calendar                 from "@/components/pages/calendar/Index.vue";
import Event                    from "@/components/pages/calendar/Event.vue";

/*For PMIS Component*/
import UserProfile              from '@/components/pages/PMIS/UserProfile.vue'
import PersonalInformation      from "@/components/pages/PMIS/PersonalInformation/index.vue";
import FamilyInformation        from "@/components/pages/PMIS/FamilyInformation/index.vue"
import AddressInformation       from "@/components/pages/PMIS/AddressInformation/index.vue"
import EducationalInformation   from "@/components/pages/PMIS/EducationalInformation/index.vue"
import ForeignTrip              from "@/components/pages/PMIS/ForeignTrip.vue"

const routes = [
  {
    path: "/",
    component: AuthLayout,
    children: [
      { path: "/", name: "Login", component: Login },
      { path: "/login", name: "LoginRoute", component: Login },
    ],
    meta: { title: "Login" },
  },

  {
    path: "/",
    component: DashboardLayout,
    children: [
      { path: "dashboard", name: "Dashboard", component: Dashboard, meta: { title: "Dashboard" } },
      { path: "users", name: "Users", component: Users, meta: { title: "Users" } },
      { path: "calendar", name: "Calendar", component: Calendar, meta: { title: "Calendar" } },
      { path: "event", name: "Event", component: Event, meta: { title: "Event" } },
      { path: "user-profile", name: "UserProfile", component: UserProfile, meta: { title: "User Profile" } },
      { path: "personal-information", name:"PersonalInformation", component: PersonalInformation, meta:{title: "Personal Information"}},
      { path: "family-information", name:"FamilyInformation", component: FamilyInformation, meta:{title: "Family Information"}},
      { path: "address-information", name:"AddressInformation", component: AddressInformation, meta:{title: "Address Information"}},
      { path: "educational-information", name:"EducationalInformation", component: EducationalInformation, meta:{title: "Educational Information"}},
      { path: "foreign-trip", name:"ForeignTrip", component: ForeignTrip, meta:{title: "Foreign Trip"}},
    ],

    meta: { requiresAuth: true },
  },

  {
    path: "/:catchAll(.*)",
    component: DashboardLayout,

    children: [
      {
        path: "",
        name: "NotFound",
        component: NotFound,
        meta: { title: "404 Not Found" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

/* NProgress Config */
NProgress.configure({
  showSpinner: false,
  minimum: 0.08,
  easing: 'ease',
  speed: 800,
  trickle: true,
  trickleSpeed: 300
});

/* Before Route */
router.beforeEach((toRoute, fromRoute, next) => {
  /* Start Progress */
  NProgress.start();
  /* Page Title */
  window.document.title = toRoute.meta && toRoute.meta.title ? "EMS | " + toRoute.meta.title : "EMS";
  /* Auth Check */
  if (toRoute.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn === false) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
/* After Route */
router.afterEach(() => {
  setTimeout(() => {
    NProgress.done()
  }, 400)
})

export default router;